import React from 'react';
import { AppBar, Toolbar, Typography, Button, Container, makeStyles } from '@material-ui/core';
import { useAuth } from '../contexts/AuthContext';
import NotificationBadge from './NotificationBadge';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    title: {
        flexGrow: 1,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}));

const Layout = ({ children }) => {
    const classes = useStyles();
    const { user, logout } = useAuth();

    return (
        <div className={classes.root}>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        Twilio SMS Inbox
                    </Typography>
                    {user && (
                        <>
                            <NotificationBadge />
                            <Button color="inherit" onClick={logout}>
                                Logout
                            </Button>
                        </>
                    )}
                </Toolbar>
            </AppBar>
            <Toolbar /> {/* This adds padding below the app bar */}
            <Container maxWidth="lg" className={classes.content}>
                {children}
            </Container>
        </div>
    );
};

export default Layout;